module.exports = __webpack_public_path__ + "static/04-aedf51acd2bf90d9eee831ef863b5024.jpg";